module.exports = __webpack_public_path__ + "static/Chowly-927897ba6b52d3118b1e0518fb7b1b17.jpg";